import React from 'react';
import './styles.scss';
import {strings} from '../../util/strings';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {Column, Row} from '../../components/layout';
import Header1 from '../../components/headers/header1';
import AppButton from '../../components/app-button';
import * as fonts from '../../util/fonts';
import colors from '../../util/colors';
import _ from 'lodash';
import chatbotIcon from '../../assets/chatbot.svg';
import whatsappIcon from '../../assets/whatsapp.svg';

interface TalkWithUsProps {
  labels: typeof strings.pt.talkWithUs;
}

function TalkWithUs({
  labels,
}: TalkWithUsProps) {
  const openChatbot = (): void => {
    let chatbotElement: HTMLElement = document.getElementsByClassName('floating-logo')[0] as HTMLElement;
    
    if (chatbotElement) {
      (window as any).__openingChatbotProgrammatically = true;
      chatbotElement.click();
      setTimeout(() => {
        delete (window as any).__openingChatbotProgrammatically;
      }, 200);
    }
  }

  return (
    <Column className="reimbursement-history-container ">
      <Row className="reimbursement-history-titlerow reimbursement-history-row">
        <Column className="reimbursement-history-titlecolumn">
          <Header1
            className="reimbursement-history-heading1 talk-with-us-heading"
            style={{...fonts.XL, ...fonts.Bold}}>
            {labels?.talkWithUs_title}
          </Header1>
          <label style={{...fonts.M}}>
            {labels?.talkWithUs_subtitle}
            <span style={{...fonts.M}} className="talk-with-us-text-contact"> {labels?.talkWithUs_whatsappTitle}</span>
          </label>
        </Column>
      </Row>
      <div className="talk-with-us-container">
        <div className="column-center">
          <label style={{...fonts.M}} className="talk-with-us-text-contact-title">{labels?.talkWithUs_whatsappTitle}</label>
          <AppButton 
            variant='whatsapp'
            telemetryId="fale_connosco.button_whatsapp"
            telemetryLabel={labels?.talkWithUs_whatsappButtonTitle || 'Fale connosco'}
            telemetrySection="fale-connosco"
          >
            <a href={labels?.talkWithUs_whatsappLink} className="talk-with-us-button-content" target="_blank" rel="noreferrer">
              <img
                src={whatsappIcon}
                width={35}
                height={25}
                className="talk-with-us-icon"
                alt="whatsapp"
              />
              <div className="talk-with-us-button-text-content">
                <span style={{...fonts.S, ...fonts.Light, color: colors.white}}>{_.toUpper(labels?.talkWithUs_whatsappButtonTitle)}</span>
                <span style={{...fonts.MM, ...fonts.Bold, color: colors.white}} className="subtitle">{labels?.talkWithUs_whatsappButtonSubitle}</span>
              </div>
            </a>
          </AppButton>
        </div>
        <div className="column-center">
          <label style={{...fonts.M}} className="talk-with-us-text-chatbot-title">{labels?.talkWithUs_chatbotTitle}</label>
          <AppButton 
            variant='chatbot'
            telemetryId="fale_connosco.button_assistente_virtual"
            telemetryLabel={labels?.talkWithUs_chatbotButtonTitle || 'Assistente Virtual'}
            telemetrySection="fale-connosco"
            onClick={openChatbot}
          >
            <div className="talk-with-us-button-content">
              <img
                src={chatbotIcon}
                width={35}
                height={25}
                className="talk-with-us-icon"
                alt="chatbot"
              />
              <div className="talk-with-us-button-text-content">
                <span style={{...fonts.MM, ...fonts.Bold, color: colors.white}} className="subtitle">{labels?.talkWithUs_chatbotButtonTitle}</span>
              </div>
            </div>
          </AppButton>
        </div>
      </div>
    </Column>
  );
}

const mapStateToProps = ({
  strings,
}: any) => ({
  labels: strings.value.pt.talkWithUs,
});

export default compose(
  connect(mapStateToProps)(TalkWithUs)
);
